import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PurgeListService } from 'src/app/_services/purge-list.service';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { empty } from 'rxjs';
import { RetentionService } from 'src/app/_services/retention.service';

@Component({
  selector: 'app-purge-list',
  templateUrl: './purge-list.component.html',
  styleUrls: ['./purge-list.component.scss']
})
export class PurgeListComponent implements OnInit {
  allPurgeList: any;
  purgeList = [];
  displayedColumns = ["select", "title", "disposition_date", "name", "actions"];
  errorHTTP: string;
  error: string[];
  selection = new SelectionModel<any>(true, []);
  emptyApprove: boolean = false;
  selectedDocs: any[];
  docId: any[] = [];
  filterValue: string;
  purgeApproved: boolean = false;
  allRetentionList: any;
  hideDocList: boolean = false;
  documentId: any;
  allSelected: boolean = false;
  purgeListEmpty: boolean = false;

  constructor(
    private purgeListService: PurgeListService,
    private retentionService: RetentionService,
  ) { }

  sort
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.allPurgeList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.allPurgeList.paginator = this.paginator;
    }
  }

  ngOnInit() {
    this.purgeListService.getPurgeList().subscribe(purgeList => {
      //console.log("Purge", purgeList)
      if (purgeList == "No documents to be purged") {
        this.purgeListEmpty = true
        this.allPurgeList = null
        this.purgeList = []
      }
      else {
        this.purgeList = purgeList;
        this.allPurgeList = new MatTableDataSource(purgeList);
        this.allPurgeList.sort = this.sort;
        this.allPurgeList.paginator = this.paginator;
      }
    })
    // this.retentionService.getRetention().subscribe(retentionList => {
    //   this.allRetentionList = retentionList
    // })
  }

  approvePurgeDocumentArray($event) {
    this.docId = []
    //console.log(this.selection.selected)
    if (this.selection.selected.length == 0) {
      this.emptyApprove = true
    }
    else {
      this.selectedDocs = Object.assign([], this.selection.selected)
      //console.log(this.selectedDocs)
      this.selectedDocs.forEach((element, index) => {
        this.docId.push(<string>element.document_id);
      })
      console.log(this.docId)
      this.purgeListService.approvePurge(this.docId).subscribe(data => {
        //console.log("Success!")
        this.purgeApproved = true
        this.selection.clear()
        //alert("Approved to Purge all the documents successfully!")
        //this.ngOnInit()
      })
    }
  }

  back() {
    this.emptyApprove = false
    this.purgeApproved = false
    this.ngOnInit()
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.allPurgeList.data.length;
    //console.log("Selected", this.selection.selected)
    return numSelected === numRows;
  }

  masterToggle() {
    //console.log(this.selection.selected)
    this.isAllSelected() ?
      this.selection.clear() :
      this.selecteAll()
  }

  selecteAll() {
    if (this.filterValue) {
      this.allPurgeList.filter = this.filterValue.trim().toLowerCase();
      //console.log(this.allPurgeList.filteredData)
      this.allPurgeList.filteredData.forEach(row => {
        this.selection.select(row)
      });
    }
    else {
      this.allPurgeList.data.forEach(row => this.selection.select(row));
    }
  }

  // checkboxLabel(row?: any): string {
  //   if (!row) {
  //     //console.log("ALL")
  //     return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
  //   }
  //   //console.log("OUT")
  //   return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row 
  //   ${row.position + 1}`;
  // }


  approvePurgeDocument($event, docId) {
    this.docId = []
    this.docId.push(docId)
    this.purgeListService.approvePurge(this.docId).subscribe(data => {
      this.purgeApproved = true
      this.selection.clear()
      //alert("Approved to Purge " + docId + " successfully!")
      //this.ngOnInit()
    },
      error => {
        console.log("Error")
        this.selection.clear()
        //alert("ERROR: " + error.error[0])
      }
    )
  }

  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.allPurgeList.filter = this.filterValue.trim().toLowerCase();
    if (this.allPurgeList.paginator) {
      this.allPurgeList.paginator.firstPage();
    }
  }

  getDocDetails(event, docId) {
    this.hideDocList = true;
    this.documentId = docId;
  }

  onHideDocList(hide: boolean) {
    //console.log("inside emit");
    if (hide) {
      this.hideDocList = true;
    } else {
      this.hideDocList = false;
      //this.selectCategory(this.categoryName, this.categoryId)
    }
  }
}
